import { computed } from 'vue'

import { useBillingStore } from '@/features/billing/store'
import { formatPrice } from '@/shared/utils/money'

export function useOutstandingBalance() {
  const billingStore = useBillingStore()

  const breakdown = computed(
    () => billingStore.billing?.upcomingDetails.upcomingBilling?.breakdown ?? []
  )

  const hasOutstandingBalance = computed(() =>
    breakdown.value.some((item) => item.outstanding)
  )

  const outstandingBalance = computed(() => {
    const total = breakdown.value.reduce(
      (acc, item) => acc + (item.outstanding ? item.amount || 0 : 0),
      0
    )

    return formatPrice({
      amount: total / 100,
      currency: billingStore.billing?.upcomingDetails.upcomingBilling?.currency,
    })
  })

  return { hasOutstandingBalance, outstandingBalance }
}
